document.querySelectorAll('drawer-component').forEach(drawer => {
  drawer.addEventListener('click', function(e) {
    const inner = drawer.querySelector('.drawer__inner');
    const closeBtn = inner.querySelector('.drawer__close');
    if (!inner.contains(e.target) && closeBtn) {
      closeBtn.click();
    }
  });
});



document.querySelectorAll('button.readmore').forEach(button => {
  button.addEventListener('click', function () {
    const parent = this.closest('.collection-description');
    if (parent) {
      parent.classList.add('expanded');
    }
  });
});

if (jQuery(".center-single-slick").length > 0) {
  jQuery(".center-single-slick").slick({
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: true,
  });
}

if (jQuery(".grid-4-slick").length > 0) {
  jQuery(".grid-4-slick").slick({
    slidesToShow: 4,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });
}
if (jQuery(".gallery-silder-inner").length > 0) {
  jQuery(".gallery-silder-inner").slick({
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 1,
    infinite: false,
  });
}

  function addToCart(productId, button) {
    let textSpan = button.querySelector(".text");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: productId, quantity: 1 }),
    })
      .then((response) => response.json())
      .then(() => {
        textSpan.textContent = "Remove sample";
        button.setAttribute("data-action", "remove");
        updateCartUI();
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }

  function removeFromCart(productId, button) {
    let textSpan = button.querySelector(".text");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: productId, quantity: 0 }),
    })
      .then((response) => response.json())
      .then(() => {
        textSpan.textContent = "Add sample";
        button.setAttribute("data-action", "add");
        updateCartUI();
      })
      .catch((error) => console.error("Error removing from cart:", error));
  }

  function myGetSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  function updateCartUI() {
    fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then((response) => response.json())
      .then((data) => {
        // Update Cart Drawer
        document.getElementById("CartDrawerWrapper").innerHTML =
          myGetSectionInnerHTML(data["cart-drawer"], "#CartDrawerWrapper");
        document.getElementById("cart-icon-bubble").innerHTML =
          myGetSectionInnerHTML(data["cart-icon-bubble"], ".shopify-section");
        //  document.querySelector(".cart-drawer").innerHTML = data["cart-drawer"];

        // Update Cart Icon Bubble
        //document.querySelector("#cart-icon-bubble").innerHTML = data["cart-icon-bubble"];
      })
      .catch((error) => console.error("Error updating cart UI:", error));
  }
  
 // 1. Setup reusable click handler
  function handleAjaxCartButtonClick(button) {
    let productId = button.getAttribute("data-id");
    let action = button.getAttribute("data-action");

    if (action === "add") {
      addToCart(productId, button);
    } else {
      removeFromCart(productId, button);
    }
  }

  // 2. Attach event listener to all ajax-cart-btn buttons
  document.querySelectorAll(".ajax-cart-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const grandParent = button.parentElement?.parentElement;
      if (grandParent) {
        grandParent.classList.toggle('active-fabric');
      }
      handleAjaxCartButtonClick(this);
    });
  });

  // 3. Handle URL param and simulate click action
  document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const fabricId = urlParams.get("select-fabric");

    if (fabricId) {
      const container = document.querySelector(`#product-${fabricId}`);
      if (container) {
        const button = container.querySelector("button.ajax-cart-btn");
        if (button) {
          // Instead of triggering a native click, call the handler directly
          handleAjaxCartButtonClick(button);
        }
      }
    }
  });


document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector("#Search-In-Modal-Mobile");
  const searchInputDesktop = document.querySelector("#Search-In-Modal");
  
  const menuDrawer = document.querySelector("#menu-drawer");
  const activeClass = "active-search";

   searchInputDesktop.addEventListener("input", function () {
      if (searchInputDesktop.value.trim() === "") {
        document.body.classList.remove('searching');
      } else {
        document.body.classList.add('searching');
      }
    });

  if (searchInput && menuDrawer) {
    searchInput.addEventListener("click", function (e) {
      e.stopPropagation(); // Prevent the click from bubbling up
      menuDrawer.classList.add(activeClass);
    });

    // Toggle class on input change
    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim() === "") {
        menuDrawer.classList.add(activeClass);
      } else {
        menuDrawer.classList.remove(activeClass);
      }
    });

    document.addEventListener("click", function (e) {
      // Check if the click target is outside both the input and the drawer
      if (!menuDrawer.contains(e.target) && !searchInput.contains(e.target)) {
        menuDrawer.classList.remove(activeClass);
      }
    });
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const searchInput = document.querySelector("#Search-In-Modal-Mobile");
//   const menuDrawer = document.querySelector("#menu-drawer");
//   const activeClass = "active-search"; // You can change this to whatever class you need

//   if (searchInput && menuDrawer) {
//     searchInput.addEventListener("click", function (e) {
//       e.stopPropagation(); // Prevent the click from bubbling up
//       menuDrawer.classList.add(activeClass);
//     });

//     document.addEventListener("click", function (e) {
//       // Check if the click target is outside both the input and the drawer
//       if (!menuDrawer.contains(e.target) && !searchInput.contains(e.target)) {
//         menuDrawer.classList.remove(activeClass);
//       }
//     });
//   }
// });
document.querySelectorAll(".toggle-view").forEach((btn) => {
  btn.addEventListener("click", function () {
    document
      .querySelectorAll(".toggle-view")
      .forEach((b) => b.classList.remove("active"));
    this.classList.add("active");

    const view = this.getAttribute("data-view");
    const productContainer = document.querySelector("#ProductGridContainer");

    productContainer.classList.remove("grid-view", "list-view");
    productContainer.classList.add(`${view}-view`);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const closeButton = document.querySelector(".btnclose");
  let hreaderdrawer = document.querySelector("#Details-menu-drawer-container");

  if (closeButton && hreaderdrawer) {
    closeButton.addEventListener("click", () => {
      hreaderdrawer.removeAttribute("open");
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // const hoverMenus = document.querySelectorAll("details.hover-mega");

  // hoverMenus.forEach((menu) => {
  //   const summary = menu.querySelector("summary");

  //   menu.addEventListener("mouseenter", () => {
  //     menu.setAttribute("open", true);
  //   });

  //   menu.addEventListener("mouseleave", () => {
  //     menu.removeAttribute("open");
  //   });

  //   // Prevent toggle on click (optional)
  //   summary.addEventListener("click", (e) => {
  //     e.preventDefault();
  //   });
  // });
  let items = document.querySelectorAll(".mega-menu")
  let header = document.querySelector('header')
  let currentItemIndex
  items.forEach((item, itemIndex) => {
    const content = item.querySelector(".mega-menu__content")
    item.addEventListener("mouseover", () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute("open")
      }
      currentItemIndex = itemIndex
      item.setAttribute("open", true)
    })
    item.addEventListener("mouseleave", (event) => {
      let close = true
      const closeTimeout = setTimeout(() => {
        if (close) item.removeAttribute("open")
      }, 200)
      content.addEventListener("mouseover", () => {
        close = false
      })
      item.addEventListener("mouseover", () => {
        clearTimeout(closeTimeout)
      })
    })
    content.addEventListener("mouseleave", () => {
      item.removeAttribute("open")
    })
  })
});
